import { rewardsSlice } from './rewards/rewards.slice';
import { userSlice } from './user/user.slice';

type LoyaltyActions = typeof userSlice.actions | typeof rewardsSlice.actions;

// Exporting all actions from slices in one file mimics exported variables from a context and encourages more explicit naming
// As an added benefit, we are able to see which actions come from which slice in a central location
const { setUser, setLoyaltyLoading } = userSlice.actions;

const {
  applyReward,
  createAvailableLoyaltyRewardsMap,
  rehydrateAppliedReward,
  removeAppliedReward,
  resetLoyaltyRewardsState,
  setAvailableLoyaltyRewardsMap,
  setIsPricingRewardApplication,
  setStagedCartPoints,
  unApplyReward,
} = rewardsSlice.actions;

export const loyaltyActions: LoyaltyActions = {
  // User slice actions
  setUser,
  setLoyaltyLoading,
  // Rewards slice actions
  applyReward,
  createAvailableLoyaltyRewardsMap,
  rehydrateAppliedReward,
  removeAppliedReward,
  resetLoyaltyRewardsState,
  setAvailableLoyaltyRewardsMap,
  setIsPricingRewardApplication,
  setStagedCartPoints,
  unApplyReward,
};
